export const dataLocal: any = {
    jp: {
        data1: [
            {
                items: [
                    {
                        imgs: [
                            {
                                img: 'https://websiteoss.ecoflow.com/upload/image/1731401429027/5k_silver.png',
                                text: 'シルバー',
                                color: '#DADADA',
                                showBtns: [2, 4],
                                productId: '14630813466991',
                                variantId: '51675869249903',
                                linkMore: 'https://jp.ecoflow.com/products/ecoflow-rapid-magnetic-power-bank-5000mah?variant=51675869249903',
                            },
                            {
                                img: 'https://websiteoss.ecoflow.com/upload/image/1731401428856/5k_blue.png',
                                text: 'ライトブルー',
                                color: '#C0DEFE',
                                showBtns: [2, 4],
                                productId: '14630813466991',
                                variantId: '51675870331247',
                                linkMore: 'https://jp.ecoflow.com/products/ecoflow-rapid-magnetic-power-bank-5000mah?variant=51675870331247',
                            },
                            {
                                img: 'https://websiteoss.ecoflow.com/upload/image/1731401428091/5k_black.png',
                                text: 'ブラック',
                                color: '#212121',
                                showBtns: [1],
                                productId: '14630813466991',
                                variantId: '51675870364015',
                            },
                        ],
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1731398329963/5k_pc.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1731398329371/5k_m.jpg',
                    },
                ],
                info: {
                    name: 'RAPID 5000mAh',
                    desc: '• 5000mAh\n• Qi2 15Wワイヤレス充電\n• 最大30Wの入出力に対応\n• 折りたたみ式スタンド搭載',
                    // productId: '14630813466991',
                    // variantId: '51675869249903',
                    showBtnMore: false,
                    showBtnBuy: false,
                    showBtnCart: false,
                    hideTag: true,
                    link_buy: '購入手続きへ',
                },
            },
            {
                items: [
                    {
                        imgs: [
                            {
                                img: 'https://websiteoss.ecoflow.com/upload/image/1731401428278/10k_silver.png',
                                text: 'シルバー',
                                color: '#DADADA',
                                showBtns: [2, 4],
                                productId: '14631171883375',
                                variantId: '51670335750511',
                                linkMore: 'https://jp.ecoflow.com/products/ecoflow-rapid-magnetic-power-bank-10000mah?variant=51670335750511',
                            },
                            // {
                            //     img: 'https://websiteoss.ecoflow.com/upload/image/1731401428470/10k_blue.png',
                            //     text: 'ライトブルー',
                            //     color: '#C0DEFE',
                            //     showBtns: [1],
                            //     productId: '14631171883375',
                            //     variantId: '51670335783279',
                            // },
                            {
                                img: 'https://websiteoss.ecoflow.com/upload/image/1731401428656/10k_black.png',
                                text: 'ブラック',
                                color: '#212121',
                                showBtns: [1],
                                productId: '14631171883375',
                                variantId: '51670335816047',
                            },
                        ],
                    },
                    {
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1731398330211/10k_pc.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1731398329634/10k_m.jpg',
                    },
                ],
                info: {
                    name: 'RAPID 10000mAh',
                    desc: '• 10000mAh\n• Qi2 15Wワイヤレス充電\n• 最大65Wの入出力に対応\n• デジタルディスプレイ表示',
                    // productId: '14631171883375',
                    // variantId: '51670335750511',
                    showBtnMore: false,
                    showBtnBuy: false,
                    showBtnCart: false,
                    hideTag: true,
                    link_buy: '購入手続きへ',
                },
                direction: 'rtl',
            },
        ],
        data2: [
            {
                items: [
                    {
                        imgs: [
                            {
                                img: 'https://websiteoss.ecoflow.com/upload/image/1731496791189/5k_silver.png',
                                text: 'シルバー',
                                color: '#DADADA',
                                showBtns: [2, 4],
                                productId: '14631174177135',
                                variantId: '51670338208111',
                                linkMore: 'https://jp.ecoflow.com/products/ecoflow-rapid-magnetic-power-bank-5000mah-rapid-65w-gan?variant=51670338208111',
                            },
                            {
                                img: 'https://websiteoss.ecoflow.com/upload/image/1731496790975/5k_blue.png',
                                text: 'ライトブルー',
                                color: '#C0DEFE',
                                showBtns: [2, 4],
                                productId: '14631174177135',
                                variantId: '51670338240879',
                                linkMore: 'https://jp.ecoflow.com/products/ecoflow-rapid-magnetic-power-bank-5000mah-rapid-65w-gan?variant=51670338240879',
                            },
                            {
                                img: 'https://websiteoss.ecoflow.com/upload/image/1731496790224/5k_black.png',
                                text: 'ブラック',
                                color: '#212121',
                                showBtns: [1],
                                productId: '14631174177135',
                                variantId: '51670338273647',
                            },
                        ],
                    },
                ],
                info: {
                    name: 'RAPID 5000mAh ＋ RAPID 65W GaN充電器',
                    // productId: '14631174177135',
                    // variantId: '51670338208111',
                    showBtnMore: false,
                    showBtnBuy: false,
                    showBtnCart: false,
                    hideTag: true,
                    link_buy: '購入手続きへ',
                },
            },
            {
                items: [
                    {
                        imgs: [
                            {
                                img: 'https://websiteoss.ecoflow.com/upload/image/1731496790794/10k_silver.png',
                                text: 'シルバー',
                                color: '#DADADA',
                                showBtns: [2, 4],
                                productId: '14631175029103',
                                variantId: '51670339387759',
                                linkMore: 'https://jp.ecoflow.com/products/ecoflow-rapid-magnetic-power-bank-10000mah-rapid-65w-gan',
                            },
                            // {
                            //     img: 'https://websiteoss.ecoflow.com/upload/image/1731496790415/10k_blue.png',
                            //     text: 'ライトブルー',
                            //     color: '#C0DEFE',
                            //     showBtns: [1],
                            //     productId: '14631175029103',
                            //     variantId: '51670339420527',
                            // },
                            {
                                img: 'https://websiteoss.ecoflow.com/upload/image/1731496790639/10k_black.png',
                                text: 'ブラック',
                                color: '#212121',
                                showBtns: [1],
                                productId: '14631175029103',
                                variantId: '51670339453295',
                            },
                        ],
                    },
                ],
                info: {
                    name: 'RAPID 10000mAh ＋RAPID 65W GaN充電器',
                    // productId: '14631175029103',
                    // variantId: '51670339387759',
                    showBtnMore: false,
                    showBtnBuy: false,
                    showBtnCart: false,
                    hideTag: true,
                    link_buy: '購入手続きへ',
                },
            },
        ],
    },
};
